import styled from "styled-components";
import { CreateFormTheme } from "../../../utils/themes";
import ContactCustomFields from "./ContactCustomFields";
import { forwardRef } from "react";
import { crmFormReference } from "../../../types/types";
import { useTheme } from "../../../middleware/ThemeContext";
import { LayoutWidget } from "./DND/dndTypes";
import GridStackExample, { GridStackHandle } from "./DND/GridStackExample";


interface contactOrgRoles {
  id: number;
  isPrimary: boolean;
  organization: {
    id: number;
    name: string;
    image: string;
    industry: string | null;
    createdAt: string;
  };
  role: {
    id: number;
    name: string;
  };
}

interface ContactOverViewProps {
  data: {
    cfr?: crmFormReference;
    contactOrgRoles?: contactOrgRoles[];
    // Add other properties as needed
    [key: string]: any;
  };
  refetch: () => void;
  isLoading?: boolean;
  isManagingLayout?: boolean;
  widget: LayoutWidget[];
  setWidget: React.Dispatch<React.SetStateAction<LayoutWidget[]>>;
  backUpWidgets?: LayoutWidget[];
  setIsManagingLayout?: React.Dispatch<React.SetStateAction<boolean>>;
  widgetRefetch?: () => void;
  scope: string;
  userDataRefetch?: () => void;
}

const ContactOverView = forwardRef<GridStackHandle, ContactOverViewProps>(
  (
    {
      isManagingLayout,
      data,
      refetch,
      isLoading,
      widget,
      setWidget,
      backUpWidgets,
      setIsManagingLayout,
      widgetRefetch,
      scope,
      userDataRefetch
    }: ContactOverViewProps,
    ref
  ) => {





    return (

      <>
        <div className=" mt-4">
          {/* <div className="d-flex gap-3">
          <LeftView >
            <div>
              <div className="d-flex gap-3 mb-3">
                <div className="d-flex flex-column w-50 gap-3">
                  <Email data={data} refetch={refetch} />
                  <PhoneNumber />
                  <DirectorySetting />
                </div>
                <div className="d-flex flex-column w-50 gap-3">
                  <OpenBalance />
                  <Membership />
                  <SocialMedia />
                </div>
              </div>

              <Addresses />
              <OrganizationsListing data={data} refetch={refetch} isLoading={isLoading} />
            </div>


          </LeftView>
          <RightView>
            <WidgetTabsCard tabs={tabs} />
            <ActivityLog />
          </RightView>
        </div> */}
          {/* <DndContext
          sensors={sensors}
          collisionDetection={closestCorners}
          onDragStart={handleDragStart}
          onDragOver={handleDragOver}
          onDragEnd={handleDragEnd}
        >
          <ContactPageContainer>

            <ColumnsContainer theme={theme}>
              {widgetData?.map((col) => (                
                <ColumnComponent
                  key={col.id}
                  id={col.id}
                  widgets={columns[col?.id] || []}
                  isManagingLayout={isManagingLayout!}

                />
              ))}
            </ColumnsContainer>

            <DragOverlay>
              {activeWidget ? (
                <WidgetRenderer widget={activeWidget} isManagingLayout={true} isDragging />
              ) : null}
            </DragOverlay>
          </ContactPageContainer>
        </DndContext> */}
          <GridStackExample userDataRefetch={userDataRefetch} scope={scope} widgetRefetch={widgetRefetch} ref={ref} isManageLayout={isManagingLayout} widgets={widget} setWidgets={setWidget} data={data} refetch={refetch} isLoading={isLoading} backupWidget={backUpWidgets} setIsManagingLayout={setIsManagingLayout} />
          {/* <Dashboard isManageLayout={isManagingLayout} widgets={widget} setWidgets={setWidget} /> */}
        </div>
        {/* <Row>
        <Col xs={12} md={6} lg={8}>
          <Row>
            <Col xs={12} md={12} lg={12}>
              <OrganizationsListing data={data} refetch={refetch} isLoading={isLoading} />
            </Col>
            <Col xs={12} md={6} lg={6}>

              {isLoading ? (
                <SkeletonCell style={{ height: "300px", marginBottom: "10px" }} />
              ) : (
                <ContactCustomFields data={data} refetch={refetch} isLoading={isLoading} />
              )}
            </Col>
            <Col xs={12} md={6} lg={6}>
              {isLoading ? (
                <SkeletonCell style={{ height: "100px", marginBottom: "10px" }} />
              ) : (
                <ContactEmail data={data} refetch={refetch} />
              )}
              {isLoading ? (
              <SkeletonCell style={{ height: "150px", marginBottom: "10px" }} />
            ) : (
              <ContactPhone data={data} refetch={refetch} />
            )}
              {isLoading ? (
                <SkeletonCell style={{ height: "250px", marginBottom: "10px" }} />
              ) : (
                <ContactMemberDirectory data={data} />
              )}
              {isLoading ? (
                <SkeletonCell style={{ height: "250px", marginBottom: "10px" }} />
              ) : (
                <ContactLoginActivity data={data} />
              )}
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={6} lg={4}>
          {isLoading ? (
            <SkeletonCell style={{ height: "100%", marginBottom: "10px" }} />
          ) : (
            <ActivityLog data={data} />
          )}
        </Col>
      </Row> */}
      </>
    );
  });

export default ContactOverView;

export const StyledBox = styled.div<{ bgColor?: string }>`
  border-radius: 5px;
  background: ${({ bgColor, theme }) =>
    bgColor ? bgColor : theme.CorporateTheme?.colors?.background};
  padding-bottom: 5px;
  border: 1px solid ${({ theme }) => theme.CorporateTheme.colors.border};
  box-shadow: 0px 2px 10px 0px #0000000d;
`;

// export const StyledBox = styled('div')<{ editingPhase?: boolean }>(
//   ({ theme, editingPhase }) => ({
//     backgroundColor: editingPhase
//       ? theme.CorporateTheme?.colors?.bannerBG
//       : theme.CorporateTheme?.colors?.background,
//     borderRadius: '5px',
//     border: `1px solid ${theme.CorporateTheme?.colors?.border}`,
//     boxShadow: '0px 2px 10px 0px #0000000d',
//     marginBottom: '10px',
//   })
// );

export const StyledHr = styled.div`
  margin-bottom: 15px;
  color: ${({ theme }) => theme.CorporateTheme.colors.border};
  border-bottom: 0.5px solid ${({ theme }) => theme.CorporateTheme.colors.border};
`;

export const StyledVr = styled.div`
  border-right: 1px solid ${({ theme }) => theme.CorporateTheme.colors.border};
  color: ${({ theme }) => theme.CorporateTheme.colors.border};
  height: 50px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: ${CreateFormTheme.spacing.sm};
  cursor: pointer;
  font-weight: 500;
  color: ${CreateFormTheme.colors.placeHolder};

  input {
    margin: 0;
  }
`;

const LeftView = styled.div`
width: 70%;
display: flex;
  `
const RightView = styled.div`
display: flex;
flex-direction: column;
gap: 10px;
width: 30%;
  `


export const Tag = styled.span<{ bgColor?: string, color?: string, height?: number }>`
  padding: 5px;
  background-color: ${({ bgColor, theme }) => bgColor ? bgColor : theme.CorporateTheme.colors.green};
  color: ${({ color, theme }) => color ? color : theme.CorporateTheme.colors.background};
  font-size: 12px;
  font-weight: 600;
  border-radius: 50px;
  height: ${({ height }) => height ? height + 'px' : '24px'}
`;
